import { render, staticRenderFns } from "./CosmeticAllergiesTemplate.vue?vue&type=template&id=4b914808"
import script from "./CosmeticAllergiesTemplate.vue?vue&type=script&lang=js"
export * from "./CosmeticAllergiesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports